<template>
  <div v-if="$store.state.module.id" style="padding-top: 15px">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    /* In going to entry point, redirect to courses tab */
    if (this.$route.path === "/" + this.$route.params.base || this.$route.path === "/" + this.$route.params.base + "/") {
      this.$router.push({ path: "/" + this.$route.params.base + "/courses" });
    }
  },
};
</script>

<style lang="sass" scoped>
</style>